export function getRespectiveAgeRatingNumber(rating) {
  const ratingObj = {
    G: 1,
    PG: 7,
    "15": 15,
    R: 18
  };
  return ratingObj[rating];
}
